import axios from "axios";

const createEvals = (data) => {
  return axios
    .post(`${process.env.REACT_APP_API_BASE_URL}/evaluation/create`, data)
    .then((response) => {
      return response.data;
    });
};
const createEvalReference = (data) => {
  return axios
    .post(`${process.env.REACT_APP_API_BASE_URL}/evaluation/create-eval-ref`, data)
    .then((response) => {
      return response.data;
    });
};

const allEvals = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/list?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const getEvalsByTenantId = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/by-tenant?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const meEvals = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/mesEvals?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const meEvalsDesactivee = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/mesEvalsDesactivee?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const oneEval = (evalId) => {
  return axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/evaluation/one/${evalId}`)
    .then((response) => {
      return response.data;
    });
};
const getEvalsToCompare=(ids)=>{
  return axios
   .get(`${process.env.REACT_APP_API_BASE_URL}/evaluation/getevalsbyids/${ids}`)
   .then((response) => {
      return response.data;
    });
}

const allEvalsDesactiver = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/listdesactiver?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};

const deactivateEval = (evalId) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/activate-deactivate/${evalId}`
    )
    .then((response) => {
      return response.data;
    });
};

const search = (page, size, status, keyword) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/search/by-tenant?page=${page}&size=${size}&status=${status}&keyword=${keyword}`
    )
    .then((response) => {
      return response.data;
    });
};

const searchMesEvals = (page, size, status, keyword) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/searchMesEvals?page=${page}&size=${size}&status=${status}&keyword=${keyword}`
    )
    .then((response) => {
      return response.data;
    });
};

export default {
  allEvals,
  createEvals,
  oneEval,
  meEvals,
  search,
  deactivateEval,
  allEvalsDesactiver,
  meEvalsDesactivee,
  getEvalsByTenantId,
  searchMesEvals,
  createEvalReference,
  getEvalsToCompare
};
